var map = {
	"./Administracao.vue": [
		"4434",
		"chunk-3e3c515c",
		"chunk-2ca9d6ae",
		"chunk-b4cca9cc",
		"chunk-f02eda6c",
		"chunk-b26a93fe"
	],
	"./Alimentos.vue": [
		"eb52",
		"chunk-7eaa8f59",
		"chunk-f1bd52c4",
		"chunk-2d0b2591",
		"chunk-2d0c93d8",
		"chunk-789f604e"
	],
	"./AtivacaoTeste.vue": [
		"9060",
		"chunk-40c78d44"
	],
	"./Bio.vue": [
		"9617",
		"chunk-2d0e5af9"
	],
	"./CalcularExigencias.vue": [
		"47c5",
		"chunk-2d2295ad",
		"chunk-3ba7f2b0"
	],
	"./CalcularRacao.vue": [
		"9260",
		"chunk-2d225627",
		"chunk-214a435c"
	],
	"./Consultor.vue": [
		"b586",
		"chunk-38a7b805",
		"chunk-0493f3ec"
	],
	"./CursosPremium.vue": [
		"7d17",
		"chunk-2d0e1ee9"
	],
	"./Dashboard.vue": [
		"7277",
		"chunk-1dbac3d0",
		"chunk-18782b0e",
		"chunk-0b872ca7"
	],
	"./Empresa.vue": [
		"ea01",
		"chunk-3e3c515c",
		"chunk-7db51ffe",
		"chunk-158417da",
		"chunk-c1093f34",
		"chunk-ae06f418"
	],
	"./EnviarAlimento.vue": [
		"b48a",
		"chunk-2d20f7b1"
	],
	"./Feedback.vue": [
		"6e7a",
		"chunk-51e00987"
	],
	"./Ferramentas.vue": [
		"49dd",
		"chunk-5046e134"
	],
	"./FormulacaoDieta.vue": [
		"e96a",
		"chunk-1dbac3d0",
		"chunk-2d225627",
		"chunk-78272064",
		"chunk-2d2295ad",
		"chunk-5ab62dfe"
	],
	"./Index.vue": [
		"d504",
		"chunk-2d21e30b"
	],
	"./IndexBR.vue": [
		"151b",
		"chunk-53ab1829"
	],
	"./IndexEN.vue": [
		"4e42",
		"chunk-53ad29a3"
	],
	"./Login.vue": [
		"a55b",
		"chunk-45e03a2c"
	],
	"./NotFoundPage.vue": [
		"0c8b",
		"chunk-683518fc"
	],
	"./PlanoConfinamento.vue": [
		"de26",
		"chunk-0756328d"
	],
	"./PredicaoDesempenho.vue": [
		"9264",
		"chunk-1dbac3d0",
		"chunk-2d225627",
		"chunk-78272064",
		"chunk-24dbe30e"
	],
	"./Premium.vue": [
		"e25e",
		"chunk-2d224cf3"
	],
	"./SignIn.vue": [
		"54e2",
		"chunk-fc6ed350"
	],
	"./Static.vue": [
		"04f3",
		"chunk-184bdbe1"
	],
	"./StudioRedirect.vue": [
		"8896",
		"chunk-2d0def13"
	],
	"./Suplemento.vue": [
		"bb3d",
		"chunk-1dbac3d0",
		"chunk-2d225627",
		"chunk-78272064",
		"chunk-2a35166e",
		"chunk-77c7dbc6"
	],
	"./TabelaResumida.vue": [
		"7903",
		"chunk-7eaa8f59"
	],
	"./User.vue": [
		"1511",
		"chunk-698be032"
	],
	"./adm/Ajuda.vue": [
		"c07f",
		"chunk-93f224d8"
	],
	"./adm/Dashboard.vue": [
		"50f5",
		"chunk-b4cca9cc"
	],
	"./adm/Dietas.vue": [
		"fa0b",
		"chunk-2d237123"
	],
	"./adm/Empresa/EmpresaEdit.vue": [
		"3693",
		"chunk-2d0ba1b3"
	],
	"./adm/Empresa/EmpresaNew.vue": [
		"2a23",
		"chunk-2d0bcde6"
	],
	"./adm/EmpresaControle.vue": [
		"9429",
		"chunk-2d0e5398"
	],
	"./adm/FreeMap.vue": [
		"4f23",
		"chunk-3e3c515c",
		"chunk-df195432"
	],
	"./adm/Logs.vue": [
		"a2d7",
		"chunk-2d2080fa"
	],
	"./adm/Notificacoes.vue": [
		"cfb0",
		"chunk-2d222ca7"
	],
	"./adm/Relatorio.vue": [
		"02cc",
		"chunk-2d0a3ad8"
	],
	"./adm/Reportes.vue": [
		"4eca",
		"chunk-2fdcff7f"
	],
	"./adm/ServerStatus.vue": [
		"6001",
		"chunk-8d92149a"
	],
	"./adm/SolicitacaoPremium.vue": [
		"bb9b",
		"chunk-2d21a47f"
	],
	"./adm/User/UserEdit.vue": [
		"8af7",
		"chunk-2ca9d6ae"
	],
	"./adm/User/UserNew.vue": [
		"b56f",
		"chunk-2d20fb39"
	],
	"./adm/User/UsersDialog.vue": [
		"1606",
		"chunk-2d0ab7e1"
	],
	"./adm/ValoresEPromocoes.vue": [
		"b033",
		"chunk-f02eda6c"
	],
	"./adm/VincularColaborador.vue": [
		"fb4a",
		"chunk-2d23755f"
	],
	"./adm/components/Charts.vue": [
		"a2ae",
		"chunk-2c0c1a6a"
	],
	"./adm/components/PremiumDialog.vue": [
		"0168",
		"chunk-2d0a3179"
	],
	"./alimentos/AdaptarAlimento.vue": [
		"733a",
		"chunk-f1bd52c4"
	],
	"./alimentos/Dashboard.vue": [
		"3d56",
		"chunk-f27e721a"
	],
	"./alimentos/EnviarAlimentoCQBAL.vue": [
		"57ff",
		"chunk-2d0c93d8"
	],
	"./alimentos/EnviarAlimentoPessoal.vue": [
		"2470",
		"chunk-2d0b2591"
	],
	"./alimentos/MeusAlimentos.vue": [
		"12a7",
		"chunk-7eaa8f59",
		"chunk-2d0aaecd"
	],
	"./alimentos/adaptar/ArvoreAlimentos.vue": [
		"c92e",
		"chunk-2d217e1f"
	],
	"./animal/AnimalForm.vue": [
		"2756",
		"chunk-435e43c6"
	],
	"./components/Ad.vue": [
		"94bc",
		"chunk-2d0e5992"
	],
	"./components/Ajuda.vue": [
		"c928"
	],
	"./components/Alert.vue": [
		"bbdc"
	],
	"./components/AlimentosDialog.vue": [
		"e3be",
		"chunk-2d225627"
	],
	"./components/AlimentosDialogBack.vue": [
		"3dd2",
		"chunk-2d0c5395"
	],
	"./components/AlimentosSeleciona.vue": [
		"aa05",
		"chunk-2d212b1b"
	],
	"./components/Anuncio30s.vue": [
		"2462"
	],
	"./components/AnuncioBanner.vue": [
		"9e9d"
	],
	"./components/AtivarCupom.vue": [
		"8cc0",
		"chunk-2d0e958e"
	],
	"./components/AvisoPremium.vue": [
		"24f5",
		"chunk-2d0b2b47"
	],
	"./components/Banner.vue": [
		"47e1"
	],
	"./components/BaseCardList.vue": [
		"8e29",
		"chunk-1dbac3d0"
	],
	"./components/Cartao.vue": [
		"ce30",
		"chunk-3ab78131"
	],
	"./components/ChartCard.vue": [
		"080a",
		"chunk-2d0a4b2f"
	],
	"./components/Chat.vue": [
		"8e27",
		"chunk-2d0e9728"
	],
	"./components/ClonarDieta.vue": [
		"d4ee",
		"chunk-2d21e5e6"
	],
	"./components/CompararDietas.vue": [
		"413f",
		"chunk-df3a8932"
	],
	"./components/CompartilharDialog.vue": [
		"b002",
		"chunk-2d20e786"
	],
	"./components/Cupons.vue": [
		"e108",
		"chunk-2d22486a"
	],
	"./components/DadosAnimalCard.vue": [
		"1ffe",
		"chunk-2d0b72ca"
	],
	"./components/DadosAnimalForm.vue": [
		"2654",
		"chunk-2d0b2cd9"
	],
	"./components/DashboardStart.vue": [
		"178a",
		"chunk-1dbac3d0",
		"chunk-18782b0e"
	],
	"./components/DashboardStats.vue": [
		"df56",
		"chunk-2d229b99"
	],
	"./components/DietaAtivaDialog.vue": [
		"c90e",
		"chunk-2d217de1"
	],
	"./components/DietasCard.vue": [
		"eaac",
		"chunk-1dbac3d0",
		"chunk-fb5c480c"
	],
	"./components/Exigencias.vue": [
		"dca9",
		"chunk-2d2295ad"
	],
	"./components/ExperimentePremium.vue": [
		"4688",
		"chunk-2d0c15f8"
	],
	"./components/FormularSuplemento.vue": [
		"2946",
		"chunk-1dbac3d0",
		"chunk-2d225627",
		"chunk-78272064",
		"chunk-2a35166e"
	],
	"./components/FreePages/ContentDescription.vue": [
		"ff55",
		"chunk-6a08f3e6"
	],
	"./components/FreePages/Footer.vue": [
		"3f61",
		"chunk-0d09ecdb"
	],
	"./components/FreePages/LeftLogo.vue": [
		"97c9",
		"chunk-2d0e64ca"
	],
	"./components/FreePages/LinksApp.vue": [
		"e53c",
		"chunk-2d2257f6"
	],
	"./components/GoogleMaps.vue": [
		"a32a",
		"chunk-3e3c515c",
		"chunk-7db51ffe"
	],
	"./components/HotJar.vue": [
		"d8b6"
	],
	"./components/LegendaExigencias.vue": [
		"171e",
		"chunk-2d0abbf0"
	],
	"./components/Modal.vue": [
		"582b"
	],
	"./components/NavMobile.vue": [
		"e874"
	],
	"./components/Notificacoes/Notificacoes.vue": [
		"697e"
	],
	"./components/Notificacoes/NotificacoesData.vue": [
		"c245"
	],
	"./components/PendenciasUser.vue": [
		"5242",
		"chunk-2d0c7ad1"
	],
	"./components/PostsWP.vue": [
		"a8cf",
		"chunk-2d209790"
	],
	"./components/PredicoesCard.vue": [
		"10f7",
		"chunk-1dbac3d0",
		"chunk-008e5674"
	],
	"./components/ProporcaoVC.vue": [
		"0c96",
		"chunk-2d0aed86"
	],
	"./components/QRCodeLoginPage.vue": [
		"5864",
		"chunk-2d0c9197"
	],
	"./components/Restricoes.vue": [
		"131c",
		"chunk-3d2f17a1"
	],
	"./components/ResultadoDietaEx.vue": [
		"1db9",
		"chunk-78272064"
	],
	"./components/SessoesAlerta.vue": [
		"d1f7",
		"chunk-2d21da94"
	],
	"./components/Suplemento.vue": [
		"d4b6",
		"chunk-403f2e1c"
	],
	"./components/SuplementosCard.vue": [
		"b8ed",
		"chunk-2d210c2b"
	],
	"./components/Video.vue": [
		"00f2"
	],
	"./consultor/Clientes.vue": [
		"8cfc",
		"chunk-205b48e9"
	],
	"./consultor/Dashboard.vue": [
		"5057",
		"chunk-7eec81bd"
	],
	"./consultor/Relatorio.vue": [
		"caab",
		"chunk-38a7b805"
	],
	"./consultor/VerifyAccess.vue": [
		"ea99",
		"chunk-2d22fdb2"
	],
	"./consultor/components/Menu.vue": [
		"10f5",
		"chunk-4191286d"
	],
	"./consultor/components/SelectCliente.vue": [
		"8578"
	],
	"./consultor/components/Titulo.vue": [
		"d4e6",
		"chunk-5486e7c0"
	],
	"./empresa/AddAlimento.vue": [
		"e03f",
		"chunk-9dfea758"
	],
	"./empresa/AddColaborador.vue": [
		"3101",
		"chunk-b5ca24da"
	],
	"./empresa/AddContatoEmpTecnico.vue": [
		"ed82",
		"chunk-6052df59"
	],
	"./empresa/Alimentos.vue": [
		"63e1",
		"chunk-3e3c515c",
		"chunk-7db51ffe",
		"chunk-158417da",
		"chunk-093627d6"
	],
	"./empresa/Clientes.vue": [
		"cebe",
		"chunk-9504c4e6"
	],
	"./empresa/Colaboradores.vue": [
		"1c73",
		"chunk-660d21e4"
	],
	"./empresa/Custos.vue": [
		"3ed1",
		"chunk-158417da"
	],
	"./empresa/Dashboard.vue": [
		"a5eb7",
		"chunk-3e3c515c",
		"chunk-7db51ffe",
		"chunk-c1093f34",
		"chunk-6837775f"
	],
	"./empresa/Editar.vue": [
		"afc8",
		"chunk-ee7ecc10"
	],
	"./empresa/Parceiro.vue": [
		"b2fb",
		"chunk-5cb50e06"
	],
	"./empresa/Relatorios.vue": [
		"36ca",
		"chunk-4db5a79e"
	],
	"./empresa/Topo.vue": [
		"ff17",
		"chunk-6837775f"
	],
	"./empresa/components/Menu.vue": [
		"430b",
		"chunk-2d0c09e7"
	],
	"./empresa/components/Titulo.vue": [
		"c964",
		"chunk-2d217e6a"
	],
	"./excrecao/Ambiental.vue": [
		"941d",
		"chunk-2d0e53a4"
	],
	"./financeiro/RFCenarios.vue": [
		"54b7",
		"chunk-8fdb77bc"
	],
	"./financeiro/RFCompleto.vue": [
		"abe6",
		"chunk-2d213548"
	],
	"./financeiro/RFComum.vue": [
		"a066",
		"chunk-2d2073e5"
	],
	"./financeiro/RelatorioFinanceiroSensibilidade.vue": [
		"4853",
		"chunk-8101effe"
	],
	"./proporcaoVC/PVC.vue": [
		"00a4",
		"chunk-2d0a32e9"
	],
	"./statics/Privacidade.vue": [
		"254e",
		"chunk-603e7cd2"
	],
	"./statics/Termos.vue": [
		"be29",
		"chunk-53a6f375"
	],
	"./statics/instrucoes/Apresentacao.vue": [
		"f6c5",
		"chunk-7f9acc0f"
	],
	"./statics/instrucoes/Autores.vue": [
		"590e",
		"chunk-14d4f1cf"
	],
	"./statics/instrucoes/Colaborar.vue": [
		"9740",
		"chunk-082b9f3b"
	],
	"./statics/instrucoes/Instrucoes.vue": [
		"2b1a",
		"chunk-97c16f4e"
	],
	"./statics/livros/Livro2016BR.vue": [
		"0852",
		"chunk-2d0a4b9b"
	],
	"./statics/livros/Livro2016EN.vue": [
		"7795",
		"chunk-2d0d76f2"
	],
	"./statics/livros/Livro2023BR.vue": [
		"7be5",
		"chunk-2d0e1db1"
	],
	"./statics/livros/Livro2023EN.vue": [
		"81dc",
		"chunk-2d0dda2e"
	],
	"./statics/livros/LivroBR.vue": [
		"7b2c",
		"chunk-2d0e17b2"
	],
	"./statics/livros/LivroEN.vue": [
		"02e3",
		"chunk-2d0a3ae6"
	],
	"./user/MinhasAssinaturas.vue": [
		"50d1",
		"chunk-2d0c791e"
	],
	"./user/Planos.vue": [
		"624b",
		"chunk-2d0cef60"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;